// NotFoundPage.tsx — Sprint 147 (ADR-142, R14-20).
//
// The top-level router's catch-all used to `<Navigate to={defaultLandingPath()}>`,
// so any mistyped URL silently became the launcher with no indication that the
// address was wrong. Sprint R11-8 (ADR-128) already made unknown IN-APP slugs
// honest via RouteNotFound; the outer router never got the same treatment.
//
// Deliberately NOT changed for CUSTOMER mode: Sprint 128.1 (ADR-121) relies on
// the catch-all redirect to bounce a customer who types a demo-vertical URL
// back into CondoPro. That redirect stays; only DEMO builds render this page.
import React from 'react';
import { Button, Result } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { defaultLandingPath } from '../config/customerMode';

const NotFoundPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    document.title = 'Page not found';
  }, []);

  return (
    <div style={{ padding: 48 }}>
      <Result
        status="404"
        title="Page not found"
        subTitle={`There's nothing at "${location.pathname}".`}
        extra={
          <Button type="primary" onClick={() => navigate(defaultLandingPath(), { replace: true })}>
            Go to the app launcher
          </Button>
        }
      />
    </div>
  );
};

export default NotFoundPage;
